import { render, staticRenderFns } from "./tableTwoEdit.vue?vue&type=template&id=abb43974&scoped=true&"
import script from "./tableTwoEdit.vue?vue&type=script&lang=js&"
export * from "./tableTwoEdit.vue?vue&type=script&lang=js&"
import style0 from "./tableTwoEdit.vue?vue&type=style&index=0&id=abb43974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb43974",
  null
  
)

component.options.__file = "tableTwoEdit.vue"
export default component.exports